import React from 'react';
import NavRoutes from './NavRoutes';
import Login from '../../modules/public/login/Login';
import Register from '../../modules/public/register/Register';
import ForgotPassword from '../../modules/public/forgotpassword/ForgotPassword';
import ResetPassword from '../../modules/public/resetpassword/ResetPassword';
// import ClinicGroup from '../../modules/public/createclinicgroup/CreateClinicGroup';
import PaymentsLogin from '../../modules/payments/login/PaymentsLogin';
import PaymentsDashBoard from '../../modules/payments/dashboard/PaymentsDashboard';
import PaymentsDetails, {
  AppointmentPaymentsDetails,
  PriorAuthPaymentsDetails
} from '../../modules/payments/paymentdetails/PaymentsDetails';
import GuarantorPaymentDetails from '../../modules/payments/paymentdetails/GuarantorPaymentDeatils';
import SendEmail from '../../modules/payments/sendemail/SendEmail';
import MailCheck from '../../modules/payments/mailcheck/MailCheck';
import ThanksScreen from '../../modules/payments/PaymentSuccess/ThanksScreen';
import PaymentsSection from '../../modules/payments/PaymentSection/PaymentsSection';
import CardPaymentDashboard from '../../modules/payments/CardPaymentDashboard/CardPaymentDashboard';
import PaymentRedirect from '../../modules/payments/PaymentRedirect/PaymentRedirect';
import PaymentErrorPage from '../../modules/payments/PaymentErrorPage/PaymentErrorPage';
import AcceptInvitation from '../../modules/public/AcceptInvitation/AcceptInvitation';
// import AppointmentsHomeScreen from 'src/modules/admin/AppointmentsSchedularPortal/AppointmentsHomeScreen';
import AppointmentSchedulerInit from 'src/modules/appointment-schedular/Initializer';
import ScheduleAppointmentLogin from 'src/modules/appointment-schedular/sub-modules/Login/AppointmentLogin';
import AppointmentSchedulerHome from 'src/modules/appointment-schedular/sub-modules/Home/AppointmentSchedulerHome';
import ScheduleAppointment from 'src/modules/appointment-schedular/sub-modules/ScheduleAppointment/ScheduleAppointment';
import {UploadInsuranceWrapper} from 'src/modules/appointment-schedular/sub-modules/UploadInsurance/UploadInsurance';
import AppointmentPortalWrapperHOC from 'src/modules/appointment-schedular/sub-modules/AppointmentPortalWrapperHoc';
import PatientForms from 'src/modules/payments/PatientForms/PatientForms';
import VerifyOTP from 'src/modules/public/VerifyOTP/VerifyOTP';
import GuarantorInfo from 'src/modules/payments/GuarantorInfo/GuarantorInfo';
import VoiceAssistant from 'src/modules/payments/VoiceAssistant/VoiceAssistant';

const PracticePaymentHome = React.lazy(
  () => import('../../modules/payments/PracticePayment/PracticePaymentHome')
);
const PracticePaymentCardPay = React.lazy(
  () =>
    import(
      '../../modules/payments/PracticePayment/modules/PracticePaymentCard/PracticePaymentCard'
    )
);
const PracticePaymentDetails = React.lazy(
  () =>
    import(
      '../../modules/payments/PracticePayment/modules/PracticePaymentPatientDetails/PracticePaymentDetails'
    )
);

export const CommonRoute = {
  exactFrom: '/',
  redirectTo: `/${NavRoutes.PUBLIC.LOGIN}`,
  routes: [
    {
      path: `/${NavRoutes.PUBLIC.LOGIN}`,
      component: Login,
      public: true
    },
    {
      path: `/${NavRoutes.PUBLIC.VERIFY_OTP}`,
      component: VerifyOTP,
      public: true
    },
    {
      path: `/${NavRoutes.PUBLIC.REGISTER}`,
      component: Register,
      public: true
    },
    {
      path: `/${NavRoutes.PUBLIC.FORGOT_PASSWORD}`,
      component: ForgotPassword,
      public: true
    },
    {
      path: `/${NavRoutes.PUBLIC.RESET_PASSWORD}/:token`,
      component: ResetPassword,
      public: true,
      exact: true
    },
    {
      path: `/${NavRoutes.PUBLIC.ACCEPT_INVITATION}/:token`,
      component: AcceptInvitation,
      exact: true
    },
    {
      path: `/${NavRoutes.PUBLIC.VERIFY_ACCOUNT}/:token`,
      component: ResetPassword,
      public: true,
      exact: true
    },
    {
      path: `/${NavRoutes.PUBLIC.PAYMENTS_LOGIN}/pay/:token`,
      component: PaymentsLogin,
      exact: true
    },
    {
      path: `/${NavRoutes.PUBLIC.PAYMENTS_DASHBOARD}/:token`,
      component: PaymentsDashBoard,
      exact: true
    },
    {
      path: `/${NavRoutes.PUBLIC.PAYMENTS_DETAILS}/:token/details`,
      component: PaymentsDetails,
      exact: true
    },
    {
      path: `/${NavRoutes.PUBLIC.PAYMENTS_DETAILS}/:token/appointments`,
      component: AppointmentPaymentsDetails,
      exact: true
    },
    {
      path: `/${NavRoutes.PUBLIC.PAYMENTS_DETAILS}/:token/prior-authorizations`,
      component: PriorAuthPaymentsDetails,
      exact: true
    },
    {
      path: `/${NavRoutes.PUBLIC.PAYMENTS_DETAILS}/:token/patient-forms`,
      component: PatientForms,
      exact: true
    },
    {
      path: `/${NavRoutes.PUBLIC.SEND_EMAIL}/:token`,
      component: SendEmail,
      exact: true
    },
    {
      path: `/${NavRoutes.PUBLIC.PAYMENTS_SECTION}/:token`,
      component: PaymentsSection,
      exact: true
    },
    {
      path: `/${NavRoutes.PUBLIC.MAIL_CHECK}/:token`,
      component: MailCheck,
      exact: true
    },
    {
      path: `/${NavRoutes.PUBLIC.THANKS_SCREEN}/:token`,
      component: ThanksScreen,
      exact: true
    },
    {
      path: `/${NavRoutes.PUBLIC.CARD_PAYMENT_DASHBOARD}/:token`,
      component: CardPaymentDashboard,
      exact: true
    },
    {
      path: `/${NavRoutes.PUBLIC.GUARANTOR_PAYMENT_DETAILS}/:token`,
      component: GuarantorPaymentDetails,
      exact: true
    },
    {
      path: `/${NavRoutes.PUBLIC.PAYMENT_REDIRECT}/:code`,
      component: PaymentRedirect,
      exact: true
    },
    {
      path: `/${NavRoutes.PUBLIC.PATIENT_FORM_REDIRECT}/:code`,
      component: PaymentRedirect,
      exact: true
    },
    {
      path: `/${NavRoutes.PUBLIC.PAYMENT_PRACTICE_REDIRECT}/:practiceShortCode`,
      component: PaymentRedirect,
      exact: true
    },
    {
      path: `/${NavRoutes.PUBLIC.PAYMENT_PRACTICE}/:code`,
      component: PracticePaymentHome,
      customAccess: true,
      routes: [
        {
          path: `/${NavRoutes.PUBLIC.PAYMENT_PRACTICE}/:code/${NavRoutes.PUBLIC.PAY}`,
          component: PracticePaymentCardPay,
          exact: true
        },
        {
          path: `/${NavRoutes.PUBLIC.PAYMENT_PRACTICE}/:code/${NavRoutes.PUBLIC.DETAILS}`,
          component: PracticePaymentDetails,
          exact: true
        }
      ]
    },
    {
      path: `/${NavRoutes.PUBLIC.GUARANTOR_INFO}/:token`,
      component: GuarantorInfo,
      customAccess: true,
      exact: true
    },
    {
      path: `/${NavRoutes.PUBLIC.VOICE_ASSISTANT}/:shortCode/:paymentToken`,
      component: VoiceAssistant,
      customAccess: true,
      exact: true
    },
    {
      path: `/${NavRoutes.PUBLIC.VOICE_ASSISTANT}/:shortCode`,
      component: VoiceAssistant,
      customAccess: true,
      exact: true
    },
    // {
    //   path: `/${NavRoutes.PUBLIC.APPOINTMENT_SCHEDULAR_DASHOBARD}/:token`,
    //   component: AppointmentsHomeScreen,
    //   exact: true
    // },
    {
      path: `/${NavRoutes.PUBLIC.ERROR_PAY}`,
      component: PaymentErrorPage,
      exact: true
    },
    {
      path: `/${NavRoutes.PUBLIC.APPOINTMENT_PORTAL.BASE}/:code`,
      component: AppointmentSchedulerInit,
      customAccess: true,
      exact: true
    },
    {
      path: `/:practiceShortCode/${NavRoutes.PUBLIC.APPOINTMENT_PORTAL.BASE}`,
      component: AppointmentSchedulerInit,
      customAccess: true,
      exact: true
    },
    {
      path: `/${NavRoutes.PUBLIC.APPOINTMENT_PORTAL.BASE}/:code/${NavRoutes.PUBLIC.APPOINTMENT_PORTAL.LOGIN}`,
      component: ScheduleAppointmentLogin,
      customAccess: true,
      exact: true
    },
    {
      path: `/${NavRoutes.PUBLIC.APPOINTMENT_PORTAL.BASE}/:code/${NavRoutes.PUBLIC.APPOINTMENT_PORTAL.HOME}`,
      component: AppointmentPortalWrapperHOC(AppointmentSchedulerHome),
      customAccess: true,
      exact: true
    },
    {
      path: `/${NavRoutes.PUBLIC.APPOINTMENT_PORTAL.BASE}/:code/${NavRoutes.PUBLIC.APPOINTMENT_PORTAL.SCHEDULE_APPOINTMENT}`,
      component: AppointmentPortalWrapperHOC(ScheduleAppointment),
      customAccess: true,
      exact: true
    },
    {
      path: `/${NavRoutes.PUBLIC.APPOINTMENT_PORTAL.BASE}/:code/${NavRoutes.PUBLIC.APPOINTMENT_PORTAL.UPLOAD_INSURANCE}`,
      component: AppointmentPortalWrapperHOC(UploadInsuranceWrapper),
      customAccess: true,
      exact: true
    }
  ]
};
